import { CREATE_BASKETS_SUCCESS, CREATE_BASKETS_FAILURE, CREATE_BASKETS_RESET, ADD_ITEM_TO_CART_SUCCESS, ADD_ITEM_TO_CART_FAILURE, CART_DATA_ERROR_RESET, ADD_ITEM_TO_CART, HIDE_ADD_TO_CART_TOAST, DELETE_BASKET_SUCCESS, DELETE_BASKET_FAILURE, BASKET_DETAILS, BASKET_DETAILS_SUCCESS, BASKET_DETAILS_FAILURE, UPDATE_ITEM_QUANTITY, UPDATE_ITEM_QUANTITY_SUCCESS, UPDATE_ITEM_QUANTITY_FAILURE, REMOVE_LINE_ITEM, REMOVE_MULTIPLE_LINE_ITEM, REMOVE_LINE_ITEM_SUCCESS, REMOVE_LINE_ITEM_FAILURE, REMOVE_All_ITEM, REMOVE_All_ITEM_SUCCESS, REMOVE_All_ITEM_FAILURE, CART_RECOMMENDATION_RULES, CART_RECOMMENDATION_RULES_FAILURE, SHOW_CUSTOMIZATION_MODAL, GET_APPLICABLE_COUPONS, GET_APPLICABLE_COUPONS_SUCCESS, GET_APPLICABLE_COUPONS_FAILURE, APPLY_COUPONS, APPLY_COUPONS_SUCCESS, APPLY_COUPONS_FAILURE, REMOVE_COUPONS, REMOVE_COUPONS_SUCCESS, REMOVE_COUPONS_FAILURE, VALIDATE_BASKET_SUCCESS, VALIDATE_BASKET_FAILURE, VALIDATE_BASKET_RESET, RESET_CART_DATA, FLAG_NON_LOCALIZED_ADD_TO_CART, GET_NON_LOCALISED_COUPON, GET_NON_LOCALISED_COUPON_SUCCESS, GET_NON_LOCALISED_COUPON_FAILURE, GET_LOGGEDIN_NON_LOCALISED_COUPON, GET_LOGGEDIN_NON_LOCALISED_COUPON_SUCCESS, GET_LOGGEDIN_NON_LOCALISED_COUPON_FAILURE, CREATE_BASKETS_REQUEST, RESET_FLAG_NON_LOCALIZED_ADD_TO_CART, UPDATE_LINE_ITEM, SET_USER_LAST_ACTIVE_TIME, RESET_CART_REDUCER, COUPON_COPY, REDEEM_COUPON_COPY, VALIDATE_BASKET_REQUEST, REMOVE_ALL_COUPONS, REMOVE_ALL_COUPONS_SUCCESS, REMOVE_ALL_COUPONS_FAILURE, RESET_CART_FAILURE_EMPTY, UPDATE_CUSTOMER_ID_SUCCESS, UPDATE_CUSTOMER_ID_FAILURE, CUSTOMER_ID_UPDATED, ADD_ITEM_QUANTITY, RESET_ITEM_QUANTITY, BULK_UPDATE_ITEM_QUANTITY, ITEM_UPDATED_TO_CART_SUCCESS, ITEM_UPDATED_TO_CART_ERROR, QR_CODE_SCAN_TIME, UPDATE_BASKET_FLAG, ADD_PROMO_CODE, REMOVE_PROMO_CODE, ADD_EMPLOYEE_PROMO_CODE, REMOVE_EMPLOYEE_PROMO_CODE, REMOVE_ALL_PROMOS, SET_PROMOS, SHOW_INDULGENT_ADDONS, HIDE_INDULGENT_ADDONS, UPDATE_CUSTOMER_ID, CART_RESET, CATEGORY_ITEM_INDEX, UNAVAILABLE_MODIFIERS, UPDATE_CART_WITH_STORE_AND_DISPOSITION, UPDATE_CART_WITH_STORE_AND_DISPOSITION_SUCCESS, UPDATE_CART_WITH_STORE_AND_DISPOSITION_FAILURE, STORE_SCHEDULE_DATA, ORDER_READY_DATETIME_UPDATED_SUCCESS, } from '../../constants';
import DayJsUtil from '../../utils/DayJSUtils';
const initialState = {
    cartData: {},
    currentItemId: null,
    isBasketAdded: false,
    isItemAdded: false,
    isItemUpdated: false,
    isLoading: false,
    showProductListingModal: false,
    categorySelected: null,
    flatResponse: [],
    recommendRules: [],
    applicableCoupons: [],
    couponError: {},
    isCouponApplied: false,
    isCouponRemoved: false,
    addCartItemId: '',
    addCartItemPriceWithoutTax: 0,
    addCartItemPrice: 0,
    addCartFlag: false,
    addCartCustomizable: false,
    addCartSectionName: '',
    addCartImageUri: '',
    addCartNoImageUri: '',
    addCartItemName: '',
    addCartItemCategory: '',
    itemID: '',
    isAddItemLoading: false,
    isRemoveItemLoading: false,
    isRemoveAllItemLoading: false,
    isUpdateQuantityLoading: false,
    isBasketDetailsLoading: false,
    isValidateBasketError: false,
    isValidateBasketLoading: false,
    isValidateBasketSuccess: false,
    isRecommendationRuleLoading: false,
    isRemoveCouponsLoading: false,
    isCouponLoading: false,
    getCouponLoading: false,
    isBasketLoading: false,
    userLastActiveTime: undefined,
    couponCopyStatus: false,
    redeemCouponCopyStatus: false,
    itemRemove: false,
    isValidated: false,
    isQuantityUpdated: false,
    cartDataError: null,
    isCartEmptyBecauseOfFail: false,
    isCustomerIdUpdated: true,
    addItemQuantity: [],
    basketCreateDate: '',
    qrCodeScanTime: 0,
    editedIdArray: [],
    discountCode: '',
    employeeDiscountCode: '',
    showPromos: false,
    isShowIndulgentAddOns: false,
    isBasketFlag: false,
    updateCustomerFailed: false,
    itemIndex: 0,
    isCartDirty: false,
    shouldUpdateStoreWithCartData: false,
};
const cartReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case CREATE_BASKETS_RESET:
            return {
                ...state,
                isBasketAdded: false,
                isBasketLoading: false,
            };
        case ORDER_READY_DATETIME_UPDATED_SUCCESS:
            return {
                ...state,
                cartData: action.response,
            };
        case CREATE_BASKETS_SUCCESS:
        case UPDATE_CUSTOMER_ID_SUCCESS:
            return {
                ...state,
                cartData: action.response,
                isBasketAdded: true,
                isBasketLoading: false,
                isValidateBasketSuccess: false,
                isCustomerIdUpdated: true,
                updateCustomerFailed: false,
                basketCreateDate: DayJsUtil.formatValue(DayJsUtil.dayjs(), 'YYYY-MM-DD'),
            };
        case CREATE_BASKETS_FAILURE:
            return {
                ...state,
                isBasketAdded: false,
                cartData: action.response ?? {},
                isBasketLoading: false,
            };
        case UPDATE_CUSTOMER_ID:
            return {
                ...state,
                updateCustomerFailed: false,
                isBasketLoading: true,
            };
        case UPDATE_CUSTOMER_ID_FAILURE:
            return {
                ...state,
                updateCustomerFailed: true,
                cartData: action.response ?? {},
                isBasketLoading: false,
            };
        case DELETE_BASKET_SUCCESS:
            return {
                ...state,
                cartData: {},
                isBasketAdded: !(action?.response || true),
                isLoading: false,
            };
        case DELETE_BASKET_FAILURE:
            return {
                ...state,
                isBasketAdded: false,
                isLoading: false,
            };
        case ADD_ITEM_TO_CART:
            return {
                ...state,
                currentItemId: action?.postBody?.length > 0 ? action.postBody[0].Id : null,
                isItemAdded: false,
                isAddItemLoading: true,
            };
        case ADD_ITEM_TO_CART_SUCCESS:
            return {
                ...state,
                cartData: action.response,
                isItemAdded: true,
                isAddItemLoading: false,
            };
        case ADD_ITEM_TO_CART_FAILURE:
            return {
                ...state,
                currentItemId: null,
                isLoading: false,
                isAddItemLoading: false,
                cartDataError: action.response,
            };
        case CART_DATA_ERROR_RESET:
            return {
                ...state,
                cartDataError: null,
            };
        case HIDE_ADD_TO_CART_TOAST:
            return {
                ...state,
                isLoading: false,
                isItemAdded: false,
            };
        case ITEM_UPDATED_TO_CART_SUCCESS:
            return {
                ...state,
                isItemUpdated: true,
            };
        case ITEM_UPDATED_TO_CART_ERROR:
            return {
                ...state,
                isItemUpdated: false,
            };
        case BASKET_DETAILS:
            return {
                ...state,
                isBasketDetailsLoading: true,
                shouldUpdateStoreWithCartData: false,
            };
        case BASKET_DETAILS_SUCCESS:
            return {
                ...state,
                cartData: updateCartData(state.editedIdArray, action.basketDetailsResponse),
                isBasketDetailsLoading: false,
                shouldUpdateStoreWithCartData: true,
                isCartDirty: false,
            };
        case STORE_SCHEDULE_DATA:
            return {
                ...state,
                shouldUpdateStoreWithCartData: false,
            };
        case BASKET_DETAILS_FAILURE:
            return {
                ...state,
                cartData: {},
                isBasketDetailsLoading: false,
                isCartEmptyBecauseOfFail: true,
            };
        case UPDATE_BASKET_FLAG:
            return {
                ...state,
                isBasketFlag: action.isBasketFlag,
            };
        case UPDATE_LINE_ITEM:
        case UPDATE_ITEM_QUANTITY:
        case BULK_UPDATE_ITEM_QUANTITY:
            return {
                ...state,
                isUpdateQuantityLoading: true,
                isQuantityUpdated: false,
                isItemAdded: false,
            };
        case UPDATE_ITEM_QUANTITY_SUCCESS:
            return {
                ...state,
                cartData: action.basketDetailsResponse,
                editedIdArray: [...state.editedIdArray, action.editedId],
                isUpdateQuantityLoading: false,
                isQuantityUpdated: true,
                isItemAdded: action.isItemAdded,
            };
        case UPDATE_ITEM_QUANTITY_FAILURE:
            return {
                ...state,
                isCartEmptyBecauseOfFail: true,
                isUpdateQuantityLoading: false,
                isQuantityUpdated: false,
                isItemAdded: false,
            };
        case REMOVE_LINE_ITEM:
        case REMOVE_MULTIPLE_LINE_ITEM:
            return {
                ...state,
                isRemoveItemLoading: true,
                itemRemove: false,
            };
        case REMOVE_LINE_ITEM_SUCCESS:
            return {
                ...state,
                cartData: action.removeLineItemResponse,
                editedIdArray: updatedEditedArray(action.removedItemId, state.editedIdArray),
                isRemoveItemLoading: false,
                itemRemove: true,
            };
        case REMOVE_LINE_ITEM_FAILURE:
            return {
                ...state,
                isCartEmptyBecauseOfFail: true,
                isRemoveItemLoading: false,
                itemRemove: false,
            };
        case REMOVE_All_ITEM:
            return {
                ...state,
                isRemoveAllItemLoading: true,
            };
        case REMOVE_All_ITEM_SUCCESS:
            return {
                ...state,
                cartData: action.removeAllItemResponse,
                editedIdArray: [],
                isRemoveAllItemLoading: false,
            };
        case REMOVE_All_ITEM_FAILURE:
            return {
                ...state,
                isCartEmptyBecauseOfFail: true,
                isRemoveAllItemLoading: false,
            };
        case SHOW_CUSTOMIZATION_MODAL:
            return {
                ...state,
                showProductListingModal: action.payload.showProductListingModal,
                categorySelected: action.payload.categorySelected,
            };
        case CART_RECOMMENDATION_RULES:
            return {
                ...state,
                isRecommendationRuleLoading: true,
            };
        case CART_RECOMMENDATION_RULES_FAILURE:
            return {
                ...state,
                recommendRules: null,
                isRecommendationRuleLoading: false,
            };
        // case CART_RECOMMENDATION_RULES_SUCCESS:
        //   const detailsResponse =
        //     action.recommendationRulesResponse.baskets[0].recommendedItems
        //       ?.length &&
        //     action.recommendationRulesResponse.baskets[0].recommendedItems?.map(
        //       (data) => {
        //         const product = {
        //           id: data.id,
        //           displayOrder: data.sortOrder,
        //         };
        //         return product;
        //       },
        //     );
        //   return {
        //     ...state,
        //     recommendRules: updatedRecommendedProducts(
        //       detailsResponse,
        //       action.flatResponse,
        //     ),
        //     isRecommendationRuleLoading: false
        //   };
        // case GET_APPLICABLE_COUPONS:
        //   return {
        //     ...state,
        //     applicableCoupons: [],
        //     couponError: {},
        //     isCouponApplied: false,
        //     isCouponRemoved: false,
        //     getCouponLoading: true,
        //   };
        // case GET_APPLICABLE_COUPONS_SUCCESS:
        //   return {
        //     ...state,
        //     applicableCoupons: action.response,
        //     couponError: {},
        //     isCouponApplied: false,
        //     isCouponRemoved: false,
        //     getCouponLoading: false,
        //   };
        case GET_APPLICABLE_COUPONS_FAILURE:
        case GET_NON_LOCALISED_COUPON_FAILURE:
        case GET_LOGGEDIN_NON_LOCALISED_COUPON_FAILURE:
            return {
                ...state,
                applicableCoupons: [],
                couponError: {},
                isCouponApplied: false,
                isCouponRemoved: false,
                getCouponLoading: false,
            };
        case APPLY_COUPONS:
            return {
                ...state,
                couponError: {},
                isCouponApplied: false,
                isCouponRemoved: false,
                isBasketAdded: false,
                isCouponLoading: true,
            };
        case APPLY_COUPONS_SUCCESS:
            return {
                ...state,
                cartData: action.response,
                couponError: {},
                isCouponApplied: true,
                isCouponRemoved: false,
                isBasketAdded: true,
                isCouponLoading: false,
            };
        case APPLY_COUPONS_FAILURE:
            return {
                ...state,
                couponError: action.response,
                isCouponApplied: false,
                isCouponRemoved: false,
                isBasketAdded: false,
                isCouponLoading: false,
            };
        case REMOVE_COUPONS:
        case REMOVE_ALL_COUPONS:
            return {
                ...state,
                isRemoveCouponsLoading: true,
            };
        case REMOVE_COUPONS_SUCCESS:
            return {
                ...state,
                cartData: action.removeCouponResponse,
                couponError: {},
                isCouponApplied: false,
                isCouponRemoved: true,
                isBasketAdded: true,
                isRemoveCouponsLoading: false,
            };
        case REMOVE_COUPONS_FAILURE:
            return {
                ...state,
                isBasketAdded: false,
                isCouponApplied: false,
                isCouponRemoved: false,
                couponError: action.removeCouponResponse,
                isRemoveCouponsLoading: false,
            };
        case UNAVAILABLE_MODIFIERS:
            return {
                ...state,
                unavailableModifiersData: action.payload,
            };
        case VALIDATE_BASKET_REQUEST:
            return {
                ...state,
                isValidated: false,
                isValidateBasketLoading: true,
                isValidateBasketError: false,
                isValidateBasketSuccess: false,
            };
        case UPDATE_CART_WITH_STORE_AND_DISPOSITION:
            return {
                ...state,
                shouldUpdateStoreWithCartData: false,
                isCartDirty: true,
            };
        case UPDATE_CART_WITH_STORE_AND_DISPOSITION_SUCCESS:
            return {
                ...state,
                cartData: action.response,
                shouldUpdateStoreWithCartData: true,
                validateDisposition: action?.response?.validationResult?.items?.excludedItems || [],
                isValidated: action?.response?.validationResult?.overAll?.status || false,
                isValidateBasketLoading: false,
                isValidateBasketError: false,
                isValidateBasketSuccess: true,
                isCartDirty: false,
            };
        case VALIDATE_BASKET_SUCCESS:
            return {
                ...state,
                cartData: { ...action.response, recommendedItems: state?.cartData?.recommendedItems },
                validateDisposition: action?.response?.validationResult?.items?.excludedItems || [],
                isValidated: action?.response?.validationResult?.overAll?.status || false,
                isValidateBasketLoading: false,
                isValidateBasketError: false,
                isValidateBasketSuccess: true,
            };
        case VALIDATE_BASKET_FAILURE:
        case UPDATE_CART_WITH_STORE_AND_DISPOSITION_FAILURE:
            return {
                ...state,
                isValidateBasketLoading: false,
                isValidateBasketError: true,
                isValidateBasketSuccess: false,
            };
        case VALIDATE_BASKET_RESET:
            return {
                ...state,
                isValidated: false,
                isValidateBasketError: false,
                isValidateBasketSuccess: false,
            };
        case RESET_CART_DATA:
            return {
                ...state,
                isCouponApplied: false,
                isCouponRemoved: false,
                isCouponLoading: false,
                itemRemove: false,
                isQuantityUpdated: false,
            };
        case FLAG_NON_LOCALIZED_ADD_TO_CART:
            return {
                ...state,
                addCartItemId: action.payload.itemId,
                addCartItemPrice: action.payload.itemPrice,
                addCartFlag: action.payload.setFlag,
                addCartCustomizable: action.payload.customizable,
                addCartSectionName: action.payload.sectionName,
                addCartImageUri: action.payload.imageURIValue,
                addCartNoImageUri: action.payload.noImage,
                addCartItemName: action.payload.itemName,
                addCartItemCategory: action.payload.catergoryName,
                addCartItemPriceWithoutTax: action.payload.priceWithoutTaxValue,
            };
        case RESET_FLAG_NON_LOCALIZED_ADD_TO_CART:
            return {
                ...state,
                addCartItemId: '',
                addCartItemPrice: '',
                addCartFlag: false,
                addCartCustomizable: false,
                addCartSectionName: '',
                addCartImageUri: '',
                addCartNoImageUri: '',
                addCartItemName: '',
                addCartItemCategory: '',
                addCartItemPriceWithoutTax: '',
            };
        case GET_NON_LOCALISED_COUPON:
        case GET_LOGGEDIN_NON_LOCALISED_COUPON:
        case GET_APPLICABLE_COUPONS:
            return {
                ...state,
                couponError: {},
                isCouponApplied: false,
                isCouponRemoved: false,
                getCouponLoading: true,
            };
        case GET_NON_LOCALISED_COUPON_SUCCESS:
        case GET_LOGGEDIN_NON_LOCALISED_COUPON_SUCCESS:
        case GET_APPLICABLE_COUPONS_SUCCESS:
            return {
                ...state,
                applicableCoupons: action.response,
                couponError: {},
                isCouponApplied: false,
                isCouponRemoved: false,
                getCouponLoading: false,
            };
        // case GET_NON_LOCALISED_COUPON_FAILURE:
        //   return {
        //     ...state,
        //     applicableCoupons: [],
        //     couponError: {},
        //     isCouponApplied: false,
        //     isCouponRemoved: false,
        //     getCouponLoading: false,
        //   };
        // case GET_LOGGEDIN_NON_LOCALISED_COUPON:
        //   return {
        //     ...state,
        //     applicableCoupons: [],
        //     couponError: {},
        //     isCouponApplied: false,
        //     isCouponRemoved: false,
        //     getCouponLoading: true,
        //   };
        // case GET_LOGGEDIN_NON_LOCALISED_COUPON_SUCCESS:
        //   return {
        //     ...state,
        //     applicableCoupons: action.response,
        //     couponError: {},
        //     isCouponApplied: false,
        //     isCouponRemoved: false,
        //     getCouponLoading: false,
        //   };
        // case GET_LOGGEDIN_NON_LOCALISED_COUPON_FAILURE:
        //   return {
        //     ...state,
        //     applicableCoupons: [],
        //     couponError: {},
        //     isCouponApplied: false,
        //     isCouponRemoved: false,
        //     getCouponLoading: false,
        //   };
        case CREATE_BASKETS_REQUEST:
            return {
                ...state,
                isBasketAdded: false,
                isBasketLoading: true,
            };
        case SET_USER_LAST_ACTIVE_TIME:
            return {
                ...state,
                userLastActiveTime: action.currentTime,
            };
        case RESET_CART_REDUCER:
            const { qrCodeScanTime } = state;
            return {
                ...initialState,
                qrCodeScanTime,
            };
        case COUPON_COPY:
            return {
                ...state,
                couponCopyStatus: action.payload,
            };
        case REDEEM_COUPON_COPY:
            return {
                ...state,
                redeemCouponCopyStatus: action.payload,
            };
        case REMOVE_ALL_COUPONS_SUCCESS:
            return {
                ...state,
                cartData: action.removeAllCouponResponse,
                couponError: {},
                isCouponApplied: false,
                isCouponRemoved: true,
                isBasketAdded: true,
                isRemoveCouponsLoading: false,
            };
        case REMOVE_ALL_COUPONS_FAILURE:
            return {
                ...state,
                isBasketAdded: false,
                isCouponApplied: false,
                isCouponRemoved: false,
                couponError: action.removeAllCouponResponse,
                isRemoveCouponsLoading: false,
            };
        case RESET_CART_FAILURE_EMPTY:
            return {
                ...state,
                isCartEmptyBecauseOfFail: false,
            };
        case CUSTOMER_ID_UPDATED:
            return {
                ...state,
                isCustomerIdUpdated: action.payload,
            };
        case ADD_ITEM_QUANTITY:
            const { basketLineItemId } = action.payload;
            let qtyArray = [...state.addItemQuantity];
            const index = qtyArray.findIndex((item) => item.basketLineItemId === basketLineItemId);
            if (index > -1) {
                qtyArray.splice(index, 1);
            }
            qtyArray.push(action.payload);
            return {
                ...state,
                addItemQuantity: [...qtyArray],
            };
        case RESET_ITEM_QUANTITY:
            return {
                ...state,
                addItemQuantity: [],
            };
        case SHOW_INDULGENT_ADDONS:
            return {
                ...state,
                isShowIndulgentAddOns: true,
            };
        case HIDE_INDULGENT_ADDONS:
            return {
                ...state,
                isShowIndulgentAddOns: false,
            };
        case QR_CODE_SCAN_TIME:
            return {
                ...state,
                qrCodeScanTime: action?.time ?? DayJsUtil.setUnix(DayJsUtil.dayjs()),
            };
        case ADD_PROMO_CODE:
            return {
                ...state,
                discountCode: action.payload,
            };
        case REMOVE_PROMO_CODE:
            return {
                ...state,
                discountCode: '',
            };
        case ADD_EMPLOYEE_PROMO_CODE: {
            return {
                ...state,
                employeeDiscountCode: action.payload,
            };
        }
        case REMOVE_EMPLOYEE_PROMO_CODE:
            return {
                ...state,
                employeeDiscountCode: '',
            };
        case CART_RESET:
            return {
                ...initialState,
            };
        case CATEGORY_ITEM_INDEX:
            return {
                ...state,
                itemIndex: action.i,
            };
        case REMOVE_ALL_PROMOS:
            return {
                ...state,
                discountCode: '',
                employeeDiscountCode: '',
            };
        case SET_PROMOS:
            return {
                ...state,
                showPromos: action.bool,
            };
        default:
            return state;
    }
};
export const updateCartData = (editedIdArray, basketDetailsResponse) => {
    const editedArray = [...new Set(editedIdArray)];
    const updatedFoodLinesData = basketDetailsResponse?.foodLines?.map((val) => {
        let arrayItem = Object.assign({}, val);
        if (editedArray.includes(val.id)) {
            arrayItem.itemEdited = true;
        }
        return arrayItem;
    });
    return { ...basketDetailsResponse, foodLines: updatedFoodLinesData };
};
export const updatedEditedArray = (removedItemId, editedIdArray) => {
    const editedArray = [...new Set(editedIdArray)];
    return editedArray?.filter((item) => item !== removedItemId);
};
export default cartReducer;
